import { GuideModelStateType } from './guide';

export const GUIDE_SYS_INTELLIGENCE = 'intelligence';
// Competitor新手引导
export const GUIDE_TYPE_INTELLIGENCE_COMPETITOR = 'intelligence-competitor';
// Company新手引导
export const GUIDE_TYPE_INTELLIGENCE_COMPANY = 'intelligence-company';
// Genre Profile、Market Profile新手引导
export const GUIDE_TYPE_INTELLIGENCE_GENRE_MARKET_PROFILE = 'intelligence-genre-market-profile';
// Market Reports新手引导
export const GUIDE_TYPE_INTELLIGENCE_MARKET_REPORTS = 'intelligence-market-reports';
// Following新手引导
export const GUIDE_TYPE_INTELLIGENCE_FOLLOWING = 'intelligence-following';
// Sources Metrics新手引导
export const GUIDE_TYPE_INTELLIGENCE_SOURCES_METRICS = 'intelligence-sources-metrics';
// 全部引导类型
export const GUIDE_TYPES_INTELLIGENCE = [
  GUIDE_TYPE_INTELLIGENCE_COMPETITOR,
  GUIDE_TYPE_INTELLIGENCE_COMPANY,
  GUIDE_TYPE_INTELLIGENCE_GENRE_MARKET_PROFILE,
  GUIDE_TYPE_INTELLIGENCE_MARKET_REPORTS,
  GUIDE_TYPE_INTELLIGENCE_FOLLOWING,
  GUIDE_TYPE_INTELLIGENCE_SOURCES_METRICS,
];

export const reducers = {
  showIntelligenceGuideModule(state: GuideModelStateType, action: any) {
    return {
      ...state,
      guideSys: action.payload ? GUIDE_SYS_INTELLIGENCE : '',
      ...{
        guideType: '',
      },
    };
  },
  showIntelligenceGuideCompetitor(state: GuideModelStateType) {
    return {
      ...state,
      ...{
        guideSys: '',
        guideType: GUIDE_TYPE_INTELLIGENCE_COMPETITOR,
      },
    };
  },
  showIntelligenceGuideCompany(state: GuideModelStateType) {
    return {
      ...state,
      ...{
        guideSys: '',
        guideType: GUIDE_TYPE_INTELLIGENCE_COMPANY,
      },
    };
  },
  showIntelligenceGuideGenreMarketProfile(state: GuideModelStateType) {
    return {
      ...state,
      ...{
        guideSys: '',
        guideType: GUIDE_TYPE_INTELLIGENCE_GENRE_MARKET_PROFILE,
      },
    };
  },
  showIntelligenceGuideMarketReports(state: GuideModelStateType) {
    return {
      ...state,
      ...{
        guideSys: '',
        guideType: GUIDE_TYPE_INTELLIGENCE_MARKET_REPORTS,
      },
    };
  },
  showIntelligenceGuideFollowing(state: GuideModelStateType) {
    return {
      ...state,
      ...{
        guideSys: '',
        guideType: GUIDE_TYPE_INTELLIGENCE_FOLLOWING,
      },
    };
  },
  showIntelligenceGuideSourcesMetrics(state: GuideModelStateType) {
    return {
      ...state,
      ...{
        guideSys: '',
        guideType: GUIDE_TYPE_INTELLIGENCE_SOURCES_METRICS,
      },
    };
  },
};
